import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgPreference = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 134 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M102.256 62.7305C110.464 42.0723 121.661 21.6406 133.101 3.06315C133.925 1.72618 132.965 0 131.395 0H2.60505C1.03491 0 0.0754333 1.72618 0.898771 3.06315C12.3393 21.6406 23.5364 42.0723 31.7439 62.7306C32.0479 63.4958 32.7862 64 33.6096 64H100.39C101.214 64 101.952 63.4958 102.256 62.7305Z",
		fill: "#C7DFFC"
	})
});
export default SvgPreference;
